import React, { useState, useEffect } from "react";
import axios from "axios";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Container, Button, Card, ListGroup } from 'react-bootstrap';
import HeroSection from "../../../../components/HeroSection.jsx";

function CreditCardList() {
  const [savedCards, setSavedCards] = useState([]);
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    // Fetch the saved credit cards from the backend

  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      console.error('Error creating payment method:', error);
    } else {
      // Send the payment method id to your server
      axios
        .post('backend-url-to-save-payment-method', { paymentMethodId: paymentMethod.id })
        .then(() => {
          // Re-fetch the saved cards to include the newly saved card
          return axios.get('backend-url-to-get-saved-cards');
        })
        .then((response) => {
          setSavedCards(response.data);
        })
        .catch((error) => {
          console.error('Error saving payment method:', error);
        });
    }
  };

  const handleDelete = (cardId) => {
    axios
      .delete(`backend-url-to-delete-card/${cardId}`)
      .then(() => {
        // Re-fetch the saved cards to exclude the deleted card
        return axios.get('backend-url-to-get-saved-cards');
      })
      .then((response) => {
        setSavedCards(response.data);
      })
      .catch((error) => {
        console.error('Error deleting card:', error);
      });
  };

  return (
    <Container className="dashboard-shell">
      <HeroSection
        accent="customer"
        eyebrow="Payments"
        title="Payment Methods"
        subtitle="Manage saved cards for quicker checkout."
      />
      <Card className="dashboard-panel mt-4">
        <Card.Header className="bg-white"><strong>Saved Credit Cards</strong></Card.Header>
        <ListGroup variant="flush">
          {savedCards.map((card) => (
            <ListGroup.Item key={card.id} className="d-flex align-items-center justify-content-between">
              <span>{card.brand} ending in {card.last4}</span>
              <Button variant="outline-danger" size="sm" onClick={() => handleDelete(card.id)}>Delete</Button>
            </ListGroup.Item>
          ))}
          {!savedCards.length && (
            <ListGroup.Item className="text-muted">No cards saved yet.</ListGroup.Item>
          )}
        </ListGroup>
      </Card>

      <Card className="dashboard-panel mt-4">
        <Card.Header className="bg-white"><strong>Add New Credit Card</strong></Card.Header>
        <Card.Body>
          <form onSubmit={handleSubmit}>
            <CardElement options={{ hidePostalCode: true }} />
            <Button variant="primary" type="submit" disabled={!stripe} className="mt-3">Add Card</Button>
          </form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default CreditCardList;
